<template>
  <div>
    <box class="ds-widget">
      <h4 class="ds-widget__title txt-5-alt">{{ title }}</h4>
      <div class="ds-widget__amount txt-2-alt">{{ formatNumber(amount) }}</div>
      <div v-if="subAmount !== -1" class="txt-5-alt ds-widget__sub-amount">
        {{ formatNumber(subAmount) }} {{ subTitle }}
      </div>
      <b-badge v-if="change" class="ds-widget__change" :variant="changeVariant">
        {{ changeValue }}%
      </b-badge>
      <slot name="link"></slot>
    </box>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      default: ''
    },
    amount: {
      type: Number,
      default: 0
    },
    subAmount: {
      type: Number,
      default: -1
    },
    isCurrency: {
      type: Boolean,
      default: false
    },
    change: {
      type: Number,
      default: 0
    }
  },

  computed: {
    changeVariant() {
      return this.change < 0 ? 'danger' : 'success';
    },
    changeValue() {
      return `${this.change > 0 ? '+' : ''}${this.change}`;
    }
  },

  methods: {
    formatNumber(value) {
      const format = this.isCurrency ? '$0,0.00' : '0,0';
      return this.$numeral(value).format(format);
    }
  }
};
</script>

<style lang="scss">
.ds-widget.box {
  padding: 1.25rem !important;
}

.ds-widget {
  font-weight: 600;
  position: relative;
  border: 1px solid $border-color;

  &__title {
    text-transform: uppercase;
    font-size: 12px;
    letter-spacing: 1px;
    padding-right: 55px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  &__amount {
    font-weight: 600;
    font-size: 20px;
  }

  &__change {
    position: absolute;
    right: 1rem;
    top: 1rem;
    letter-spacing: 1px;
  }

  &__sub-amount {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
</style>
